module.exports = __webpack_public_path__ + "media/images/donate-banner-mobile-6589046a555f08fda11e54affcb271c6.png";